import { render } from "./FixedProperties.vue?vue&type=template&id=3c77324a"
import script from "./FixedProperties.vue?vue&type=script&lang=js"
export * from "./FixedProperties.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__